<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/XQ0fmT/tc-custom/9781512491067.jpg?1719982172217" alt="This image is the cover for the book Lotsa Matzah"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Lotsa Matzah
      </h1>
      <p class="bookDescription body article font2">
        <p><i><b>With matzah, we remember well / The Seder story we all tell. </b></i></p><p><i><b></b></i>A rhyming introduction to Passover’s traditional food, with children eating and enjoying “lotsa matzah” many different ways during the holiday.</p><p>Introduce young children to Jewish life with Very First Board Books!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Tilda Balsley, Akemi Gutierrez
      </h2>
      
      <p class="authorDescription body article">Akemi Gutierrez was an assistant animator for Walt Disney Features, where her films included <I>Mulan</I>, <I>Pocahontas</I>, and <I>Tarzan</I>. Now a full-time children’s book illustrator, drawing and painting are her favorite things to do. Akemi lives in Los Angeles, California.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Kar-Ben
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?52a10bad